import React, { Fragment, useState } from "react";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import { Box, Collapse, IconButton, Table, TableBody, TableHead, Typography } from "@mui/material";
import { KeyboardArrowDown, KeyboardArrowUp } from "@mui/icons-material";
import { AlertSpg, isArrayEmpty, isArrayNotEmpty, OptionTableCell, TableButton } from "@duosoftbg/nacid-components";
import { AdminConsoleSectionDetails } from "../../../../../../../types/adminConsoleTypes";
import { useTranslation } from "react-i18next";
import AdminConsolePage from "../page/AdminConsolePage";
import {
  openDeleteModal,
  openEditModal,
} from "../../../../../../../store/redux/slice/ComponentsControl/adminConsoleConfigControl";
import { adminConsoleSection } from "../../../../../../../utils/constants";
import useAppDispatch from "../../../../../../../hooks/redux/base/useAppDispatch";
import { acPageCreationInitialValues } from "../../../../../../../init/adminConsoleCreationInitialValues";

type AdminConsoleSectionProps = {
  section: AdminConsoleSectionDetails;
};

const AdminConsoleSection = ({ section }: AdminConsoleSectionProps) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const [openSection, setOpenSection] = useState(false);
  const sectionPages = section.pages;

  const handleEditSection = (section) => {
    dispatch(openEditModal({ section: adminConsoleSection.section, object: section }));
  };

  const handleDeleteSection = (id) => {
    dispatch(openDeleteModal({ section: adminConsoleSection.section, id }));
  };

  const handleCreatePage = (parentId) => {
    dispatch(
      openEditModal({
        section: adminConsoleSection.page,
        object: { ...acPageCreationInitialValues, parentId: parentId },
      }),
    );
  };

  return (
    <Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell align="center">
          <IconButton aria-label="expand row" size="small" onClick={() => setOpenSection(!openSection)}>
            {openSection ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
          </IconButton>
        </TableCell>
        <TableCell>{section.id}</TableCell>
        <TableCell>{section.title}</TableCell>
        <TableCell>{section.titleEn}</TableCell>
        <TableCell align="center">{section.position}</TableCell>
        <OptionTableCell>
          <TableButton type={"edit"} onClick={() => handleEditSection(section)} />
          <TableButton
            onClick={() => {
              handleDeleteSection(section.id);
            }}
            type={"remove"}
          />
        </OptionTableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={openSection} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Typography variant="h6" gutterBottom component="div">
                {t("l.table.head.pages")}
              </Typography>
              <Table size="small">
                <TableHead style={{ background: "#eee" }}>
                  <TableRow>
                    <TableCell style={{ width: 35 }} />
                    <TableCell>{t("l.table.head.id")}</TableCell>
                    <TableCell>{t("l.table.head.page")}</TableCell>
                    <TableCell>{t("l.table.head.page.en")}</TableCell>
                    <TableCell>{t("l.table.head.position")}</TableCell>
                    <TableCell align="right">
                      <TableButton type={"create"} onClick={() => handleCreatePage(section.id)} />
                    </TableCell>
                  </TableRow>
                </TableHead>
                {isArrayNotEmpty(sectionPages) && (
                  <TableBody>
                    {sectionPages.map((page) => (
                      <AdminConsolePage key={page.id} page={page} depth={0} />
                    ))}
                  </TableBody>
                )}
              </Table>
              {isArrayEmpty(sectionPages) && <AlertSpg severity="info">{t("m.empty.list")}</AlertSpg>}
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </Fragment>
  );
};
export default AdminConsoleSection;
